import { Action } from 'redux';
import { SharedAppConstants } from '@tock/shared-app-constants';
import { v4 as uuidv4 } from 'uuid';

// TODO: This interface should be moved to @tock/coretypes
// It's copied from shared, and when we put this in coretypes and remove from shared,
// we will likely have to fix a LOT of imports so I'm punting in this PR

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface BaseTockAction<T = any, P = ToastProps> extends Action<string> {
  type: string;
  payload?: T;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context?: any;
  toastMessage?: P;
  serviceActionType?: 'CORE' | 'CLIENT' | 'WEBSOCKET';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  request?: any;
}

export interface ToastProps {
  type: 'info' | 'error';
  message: string | JSX.Element;
  linkText?: string;
  onClickLink?(): void;
  id?: string;
  onClear?: () => void;
}

export function showInfo(
  message: string,
  options?: Pick<ToastProps, 'linkText' | 'onClickLink' | 'onClear'>
): BaseTockAction {
  return {
    type: SharedAppConstants.SHOW_INFO_TOAST,
    toastMessage: {
      type: 'info',
      message,
      linkText: options?.linkText,
      onClickLink: options?.onClickLink,
      id: uuidv4(),
      onClear: options?.onClear,
    },
  };
}

export function showError(
  message: string | JSX.Element,
  options?: Pick<ToastProps, 'linkText' | 'onClickLink' | 'onClear'>
): BaseTockAction {
  return {
    type: SharedAppConstants.SHOW_ERROR_TOAST,
    toastMessage: {
      type: 'error',
      message,
      linkText: options?.linkText,
      onClickLink: options?.onClickLink,
      id: uuidv4(),
      onClear: options?.onClear,
    },
  };
}

export function clear(): BaseTockAction {
  return {
    type: SharedAppConstants.CLEAR_TOAST,
  };
}

export function remove(id: string): BaseTockAction {
  return {
    type: SharedAppConstants.REMOVE_TOAST,
    payload: {
      id,
    },
  };
}

export const actions = { clear, showError, showInfo, remove };
